import React, { memo } from "react";
import { Handle, Position } from "react-flow-renderer";
import { Typography } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { ContentCopy, Delete, ArrowForwardIos, Stop } from "@mui/icons-material";
import { useNodeStorage } from "../../../stores/useNodeStorage";

function EndNode({ data, isConnectable, id }) {
  const theme = useTheme();
  const storageItems = useNodeStorage();

  return (
    <div
      style={{
        backgroundColor: theme.palette.background.paper,
        padding: "12px",
        borderRadius: "8px",
        boxShadow: theme.shadows[3],
        border: `2px solid #f44336`,
        minWidth: "120px",
        textAlign: "center",
      }}
    >
      {/* Handle de entrada */}
      <Handle
        type="target"
        position={Position.Left}
        style={{
          background: "transparent",
          width: "28px",
          height: "28px",
          top: "50%",
          left: "-14px",
          cursor: "crosshair",
          border: "none",
        }}
        isConnectable={isConnectable}
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "none",
          }}
        >
          <div
            style={{
              background: `linear-gradient(145deg, #f44336 0%, #d32f2f 100%)`,
              width: "20px",
              height: "20px",
              borderRadius: "50%",
              boxShadow: theme.shadows[2],
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "none",
            }}
          >
            <ArrowForwardIos
              style={{
                color: "#fff",
                width: "12px",
                height: "12px",
                transform: "rotate(180deg)",
              }}
            />
          </div>
        </div>
      </Handle>

      {/* Botões de ação */}
      <div
        style={{
          display: "flex",
          position: "absolute",
          right: 5,
          top: 5,
          cursor: "pointer",
          gap: 6,
        }}
      >
        <ContentCopy
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          style={{
            width: "14px",
            height: "14px",
            color: theme.palette.primary.main,
          }}
        />
        <Delete
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          style={{
            width: "14px",
            height: "14px",
            color: theme.palette.error.main,
          }}
        />
      </div>

      {/* Conteúdo */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "6px",
        }}
      >
        <Stop
          style={{
            width: "24px",
            height: "24px",
            color: "#f44336",
          }}
        />
        <Typography
          variant="subtitle2"
          style={{
            fontWeight: "bold",
            color: theme.palette.text.primary,
          }}
        >
          Fim
        </Typography>
      </div>
    </div>
  );
}

export default memo(EndNode);
